import React from "react";
import { Input } from "@windmill/react-ui";

const InputAreaItineraryPrice = ({
  register,
  defaultValue,
  required,
  name,
  label,
  type,
  placeholder,
  pattern,
  minLength,
  maxLength,
  value,
  readOnly,
  onChangeFunction,
  val,
  fromCity,
  toCity,
  disabled,
}) => {
  const handleInput = (e) => {
    let val = e.target.value;

    if (val) {
      // Allow '.' for extra_km only
      if (name.startsWith("extra_km")) {
        val = val.replace(/[^0-9.]/g, ""); // Allow numbers and dot
        val = val.replace(/\.(?=.*\.)/g, ""); // Allow only one dot
      } else if (name.startsWith("duration")) {
        val = val.replace(/[^a-zA-Z0-9. ]/g, "");
      } else {
        val = val.replace(/[^0-9]/g, ""); // Allow numbers only, no dot
      }
    }
    e.target.value = val;
    const inputValue = e.target.value;
    if (inputValue.length > maxLength) {
      e.target.value = inputValue.slice(0, maxLength);
      return;
    }
  };
//console.log(fromCity,"fromcity", toCity, "tocity", value, "value");

  return (
    <>
      <Input
         {...register(name, {
          required: required
            ? `${label} is required!`
            : false || (fromCity !== toCity ? `${label} is required!` : false), // Only make required if cities are different
        })}
        defaultValue={defaultValue}
        type={type}
        placeholder={placeholder}
        name={name}
        onInput={handleInput}
        onChange={(e) => onChangeFunction ? onChangeFunction(e) : null}

        value={value}
        disabled={disabled}
        step="any"
        readOnly={readOnly}
        autoComplete="off"
        className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      />
    </>
  );
};

export default InputAreaItineraryPrice;
